import React from 'react';
import {SearchField, DataGrid, RaymanUser, UserSize, FilterMenu, Text, SmartDateLabel, SmartTagText, IconMenu, Dialog} from 'components/core';
import {Grid, SvgIcon} from '@material-ui/core';
import {Timer} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import {TasksCtx} from 'components/dataProviders/tasks';
import {TagsCtx} from 'components/dataProviders/tags';
import Singletons from 'controllers/Singletons';

const overrideStyle = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    toolbar: {
        padding: 24,
        height: 88,
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 88,
        '& .MuiGrid-item':
        {
            height: 40
        },
        '& .MuiTypography-root':
        {
            lineHeight: '40px'
        }
    },
    datagrid: {
        height: 'calc(100% - 88px)',
        '& .Mui-selected $icon':
        {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
        },
    },
    searchbox: {
        height: 40,
        width: 300
    },
    nameField: {
        display: "flex",
        flexDirection: "row",
        // lineHeight: "30px",
        overflow: "hidden"
    },
    svg:
    {
        fill: "transparent"
    },
    icon: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.main,
        borderRadius: "50%",
        padding: 8,
        width: 40,
        height: 40,
        flexBasis: 40,
        textAlign: 'center',
        lineHeight: '24px',
        alignSelf: "center",
        marginRight: 5
    },
    twoRows: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        overflow: "hidden"
    },
    nameRow:
    {
        // fontWeight: 500,
        marginLeft: 15,
        textOverflow: "ellipsis",
        overflow: "hidden"
    },
    timeRow: {
        lineHeight: "25px",
        height: 25,
        fontSize: "14px",
        display: "inline-flex",
        alignItems: "center",
        '& .MuiSvgIcon-root':
        {
            width: 16,
            height: 16,
            marginRight: 5
        }
    },
    red: {
        color: theme.palette.error.main
    }
  }), {name: "TasksGrid"});

  
  function RowMenu({row, handleEdit})
  {
      const ctx = React.useContext(TasksCtx);
      const [open, setOpen] = React.useState(false);
      const [loading, setLoading] = React.useState(false);
  
      const handleClose = () => {
          setOpen(false);
      }
  
      const handleOpen = () => {
          setOpen(true);
      }
  
      const handleConfirm = () => {
          setLoading(true);
          ctx.funcs.delete(row.taskID).then(() => {
              setLoading(false);
              setOpen(false);
          });
      }
  
      let items = [
        {
            label: "Editar",
            onClick: () => handleEdit()
        },
        {
            label: "Borrar",
            onClick: () => handleOpen(),
            danger: true
        } 
      ];
      return <>
      <Dialog title="Eliminar tarea" open={open} loading={loading} confirm="Eliminar" confirmColor="error" cancel="Cancelar" onConfirm={handleConfirm} onCancel={handleClose} onClose={handleClose}>
          ¿Está seguro? Una vez borrado no se podrá recuperar
        </Dialog>
      <IconMenu items={items} />
      </>
  }

  function NameField({row})
  {
      const classes = overrideStyle();
      return <div className={classes.nameField}>
                <div className={classes.icon}>
                    
                    <SvgIcon className={classes.svg}>
                    <path fill="currentColor" d="M22,5.18L10.59,16.6l-4.24-4.24l1.41-1.41l2.83,2.83l10-10L22,5.18z M19.79,10.22C19.92,10.79,20,11.39,20,12 c0,4.42-3.58,8-8,8s-8-3.58-8-8c0-4.42,3.58-8,8-8c1.58,0,3.04,0.46,4.28,1.25l1.44-1.44C16.1,2.67,14.13,2,12,2C6.48,2,2,6.48,2,12 c0,5.52,4.48,10,10,10s10-4.48,10-10c0-1.19-0.22-2.33-0.6-3.39L19.79,10.22z"/>
                    </SvgIcon>
                </div>
                <Text className={classes.nameRow}>{row.name}</Text>
            </div>
  }

  function DueDatesField({row})
  {
    const classes = overrideStyle();
    const overdue = row.status !== "completed" && row.maxStartDate && new Date(row.maxStartDate) <= new Date();
    
    const startBlock = row.minStartDate === null ? null : 
        <div className={classes.timeRow} key="start">
            <SvgIcon className={classes.svg}>
            <path fill="currentColor" xmlns="http://www.w3.org/2000/svg" d="M2 14H4V17H9V14L13 18L9 22V19H4V22H2V14ZM19 19V8.00005H5V12H3V5.00005C3 3.89005 3.89 3.00005 5 3.00005H6V0.998047H8V3.00005H16V0.998047H18V3.00005H19C19.5304 3.00005 20.0391 3.21076 20.4142 3.58583C20.7893 3.96091 21 4.46961 21 5.00005V19C21 20.1 20.1 21 19 21H12.83L14.83 19H19Z"/>
            </SvgIcon>
            <SmartDateLabel unformatted datetime={row.minStartDate} precission='day' />
        </div>
    ;
    const endBlock = row.maxStartDate === null ? null : 
        <div className={clsx(classes.timeRow, overdue ? classes.red : false)} key="end">
            <SvgIcon className={classes.svg}>
            <path fill="currentColor" xmlns="http://www.w3.org/2000/svg" d="M22 14V22H20V18L16 22V19H11V17H16V14L20 18V14H22ZM5 19H9V21H5C3.9 21 3 20.1 3 19V5.00005C3 4.46961 3.21071 3.96091 3.58579 3.58583C3.96086 3.21076 4.46957 3.00005 5 3.00005H6V0.998047H8V3.00005H16V0.998047H18V3.00005H19C20.11 3.00005 21 3.89005 21 5.00005V12H19V8.00005H5V19Z"/>
            </SvgIcon>
            <SmartDateLabel unformatted datetime={row.maxStartDate} precission='day' />
        </div>
    ;

    const singleBlock = row.maxStartDate !== row.minStartDate ? null : 
        <div className={clsx(classes.timeRow, overdue ? classes.red : false)} key="single">
            <SvgIcon className={classes.svg}>
            <path fill="currentColor" xmlns="http://www.w3.org/2000/svg" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
            </SvgIcon>
            <SmartDateLabel unformatted datetime={row.maxStartDate} precission='day' />
        </div>
    ;
    
    return <div className={classes.dueDatesField}>
              <div className={startBlock && endBlock ? classes.twoRows : ''}>
                  {singleBlock ? singleBlock : [startBlock, endBlock]}
              </div>
          </div>
  }

const columns = {
    name: { 
        field: 'name',
        headerName: 'Nombre de la tarea',
        flex: 1,
        renderCell: (params) => {
            return <NameField row={params.row} />
        }
    },
    dueDates: {
        field: 'dueDates',
        headerName: 'Fecha',
        width: 170,
        renderCell: (params) => {
            return <DueDatesField row={params.row} />
        },
        sortComparator: (v1, v2, row1, row2) =>
            row1.maxStartDate && row2.maxStartDate ? new Date(row1.maxStartDate) - new Date(row2.maxStartDate) : 0
    },
    lastModificationDatetime: {
        field: 'lastModificationDatetime',
        headerName: 'Ult. Modificación',
        width: 170,
        align: 'right',    
        headerAlign: 'right',
        renderCell: (params) => {
            return <>
            <SmartDateLabel unformatted datetime={params.value} />
            </>;
        }
    },
    lastModificationUser: {
        field: 'lastModificationUser',
        headerName: 'Modificado por',
        flex: 0.5,
        renderCell: (params) => {
            return <RaymanUser userID={params.value} size={UserSize.size32} />
        }
    },
    tags: {
        field: 'tags',
        headerName: 'Etiquetas',
        flex: 0.5,
        renderCell: (params) => {
            return <SmartTagText tagIDs={params.value} />
        }
    }
}

const collapsedColumns = [columns.name, columns.dueDates, columns.tags];
const extendedColumns = [columns.name, columns.dueDates, columns.lastModificationDatetime, columns.lastModificationUser, columns.tags];


const usersFilter = [
    {value: true, text: "Ver sólo mis tareas", overrideLabel: "Mis tareas"},
    {value: false, text: "Ver todas las tareas", overrideLabel: "Todas las tareas"}
]

export default function TasksList({onRowSelected = () => {}, collapsed = false, handleEdit, dataset="not_started"})
{
    const classes = overrideStyle();
    const tasksCtx = React.useContext(TasksCtx);
    const tagsCtx = React.useContext(TagsCtx);
    const [userFilterElem, setUserFilterElem] = React.useState(null);
    const [data, setData] = React.useState(tasksCtx.data.array);
    const [filters, setFilters] = React.useState({text: '', tags: []});
    const [gridColumns, setGridColumns] = React.useState([]);
    const [filterTags, setFilterTags] = React.useState([]);

    let searchTimeout = 0;

    const menuColumn = React.useMemo(() => ({
        field: 'menu',
        headerName: ' ',
        width: 40,
        align: 'center',
        disableClickEventBubbling: true,
        renderCell: (params) => {
            return <RowMenu row={params.row} handleEdit={() => handleEdit(params.row.taskID)}/>
        }
    }),[handleEdit]);


    React.useEffect(function filterData(){
        
        let tmpData = [...tasksCtx.data.array];
        
        // apply filters
        tmpData = tmpData.filter((value) => {
            let result = true;
            if(filters.text) result &= value.name.toLowerCase().includes(filters.text);
            if(filters.tags.length > 0) result &= value.tags.some(r => filters.tags.includes(r));
            if(filters.user) result &= (value.asignees.includes(filters.user));
            result &= (value.status === dataset);
            return result;
        });

        setData(tmpData);
    }, [tasksCtx, dataset, filters]);

    React.useEffect(function initializeFilterTags() {
        let tags = [];
        tagsCtx.data.array.forEach((item) => tags.push({value: item.tagID, text: item.name}));

        setFilterTags(tags);
    }, [tagsCtx]);

    

    React.useEffect(function handleColumns(){

        let gridCols = collapsed ? [...collapsedColumns] : [...extendedColumns];
        if(Singletons.userProfiles.expert || Singletons.userProfiles.admin) gridCols.push(menuColumn);
        if(dataset === "closed") gridCols.splice(gridCols.length - 2, 1, columns.closed);
        setGridColumns(gridCols);
    }, [dataset, collapsed, menuColumn]);

    const handleSelectRow = (row) =>
    {
        onRowSelected(row);
    }

    const handleSearchChange = (value) =>
    {
        if(searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            let tmpFilters = {...filters};
            tmpFilters.text = value;
            if(tmpFilters.text !== filters.text) setFilters(tmpFilters);
        }, 300);
    }

    const handleTagsChange = React.useCallback((tags) => {
        let tmpFilters = {...filters};
        tmpFilters.tags = tags;
        
        if(tmpFilters.tags.join(",") !== filters.tags.join(","))
        {
            setFilters(tmpFilters);
        }
        
    }, [filters]);

    const handleUsersChange = React.useCallback((users) => {
        let tmpFilters = {...filters};
        if(users[0]) tmpFilters.user = Singletons.currentUser.userID;
        else tmpFilters.user = false;
        if(tmpFilters.user !== filters.user)
        {
            setFilters(tmpFilters);
        }
    }, [filters]);

    React.useEffect(function createUsersFilter() {

        let disabled = true;
        let preselected = 0;
        
        if(Singletons.currentUser.profiles.includes("administrators") || Singletons.currentUser.profiles.includes("experts"))
        {
            disabled = false;
            preselected = 1;
        }
        
        setUserFilterElem(<Grid item><FilterMenu type="radio" disabled={disabled} selectedIndexes = {[preselected]} items={usersFilter} onChange={handleUsersChange}/></Grid>);
    }, [handleUsersChange]);

    let columnSorting = [{
            field: 'dueDates',
            sort: 'desc'
        }
    ];

    return <>
        <Grid container direction="row" justify="space-between" className={classes.toolbar}>
            <Grid item><SearchField className={classes.searchbox} onChange={handleSearchChange} /></Grid>
            <Grid item>
                <Grid container direction="row" justify="flex-end" spacing={2}>
                    <Grid item><Text>Filtros:</Text> </Grid>
                    <Grid item><FilterMenu label={"Etiquetas"} items={filterTags} onChange={handleTagsChange}/></Grid>
                    {userFilterElem}
                </Grid> 
            </Grid>
        </Grid>
        <DataGrid 
        rows={data}
        columns={gridColumns}
        onRowSelected = {(row) => handleSelectRow(row.data)}
        loading={tasksCtx.loading}
        density="comfortable"
        className={classes.datagrid}
        sortModel={columnSorting}
        />
    </>
}